import React, { useState, useEffect } from 'react';
import api from '../api/axios';

// The modal now accepts a `leadType` prop ('business' or 'profile')
const AssignSevakModal = ({ isOpen, onClose, lead, leadType, onAssignSuccess }) => {
    const [sevaks, setSevaks] = useState([]);
    const [selectedSevak, setSelectedSevak] = useState('');

    useEffect(() => {
        if (isOpen && lead) {
            setSelectedSevak(lead.assigned_admin_id || '');
            api.get('/hrms/admins').then(res => setSevaks(res.data));
        }
    }, [isOpen, lead]);

    const handleAssign = async () => {
        const assignUrl = `/crm/${leadType}/${lead.id}/assign_sevak`;
        try {
            await api.put(assignUrl, { sevak_id: selectedSevak || null });
            onAssignSuccess();
            onClose();
        } catch (error) {
            alert("Assignment failed.");
        }
    };

    if (!isOpen || !lead) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
                <h3 className="text-lg font-medium text-gray-900">Assign Sevak to "{lead.name}"</h3>
                <div className="mt-4">
                    <select value={selectedSevak} onChange={(e) => setSelectedSevak(e.target.value)} className="w-full mt-1 block rounded-md border-gray-300">
                        <option value="">Unassigned</option>
                        {sevaks.map(sevak => <option key={sevak.id} value={sevak.id}>{sevak.name}</option>)}
                    </select>
                </div>
                <div className="mt-6 flex justify-end gap-4">
                    <button onClick={onClose} type="button" className="px-4 py-2 border rounded-md">Cancel</button>
                    <button onClick={handleAssign} type="button" className="px-4 py-2 text-white bg-orange-600 rounded-md">Assign</button>
                </div>
            </div>
        </div>
    );
};

export default AssignSevakModal;